"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var Tabs =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Tabs, _Component);

  function Tabs(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Tabs);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Tabs).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedIndex: _this.props.selectedIndex
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_selectTab", function (index) {
      _this.setState({
        selectedIndex: index
      });
    });

    var _this$_getNumItems = _this._getNumItems(),
        numTabs = _this$_getNumItems.numTabs,
        numPanels = _this$_getNumItems.numPanels;

    if (numTabs !== numPanels) {
      throw new Error('The number of Tab components must correspond to the number of TabPanel components provided.');
    }

    return _this;
  }

  (0, _createClass2.default)(Tabs, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onSelect = this.props.onSelect;
      var selectedIndex = this.state.selectedIndex;

      if (prevState.selectedIndex !== selectedIndex && onSelect) {
        onSelect(selectedIndex);
      }
    }
  }, {
    key: "_getNumItems",
    value: function _getNumItems() {
      var children = this.props.children;
      return {
        numTabs: _react.Children.count(children[0].props.children),
        numPanels: _react.Children.count(children[1].props.children)
      };
    }
  }, {
    key: "_renderNavigation",
    value: function _renderNavigation(nav) {
      return (0, _react.cloneElement)(nav, {
        selectedIndex: this.state.selectedIndex,
        onTabClick: this._selectTab
      });
    }
  }, {
    key: "_renderContent",
    value: function _renderContent(content) {
      return (0, _react.cloneElement)(content, {
        selectedIndex: this.state.selectedIndex
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          children = _this$props.children;
      var classes = (0, _classnames.default)('Tabs', className);
      return _react.default.createElement("div", {
        className: classes
      }, this._renderNavigation(children[0]), this._renderContent(children[1]));
    }
  }]);
  return Tabs;
}(_react.Component);

exports.default = Tabs;
(0, _defineProperty2.default)(Tabs, "defaultProps", {
  selectedIndex: 0
});